<template>
	<span>
		<span v-if="showNav">
			<a
				:aria-expanded="enumCollapse"
				class="sidebar-menu-item nav-link"
				data-toggle="collapse"
				@click="enumCollapse = !enumCollapse"
			>
				<template>
					<i class="fa pr-2 fa-globe text-danger"></i>
					<span class="nav-link-text">ENUM <b class="caret"></b></span>
				</template>
			</a>
			<collapse-transition :duration="{enter: 500, leave: 500}">
				<div
					v-show="enumCollapse"
					id="collapse-just1"
					:class="enumCollapse ? 'show' : ''"
					class="collapse collapse-just"
				>
					<ul class="nav nav-sm flex-column">
						<slot v-for="(item, index) in links" name="title">
							<router-link
								:key="index"
								:target="item.link"
								class="nav-link"
								:href="item.link"
								:to="item.link"
								@click.native="linkClick"
								:title="item.description"
								b-v-tooltip.hover
							>
								<template>
									<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
									<span class="nav-link-text">{{ item.name }}</span>
								</template>
							</router-link>
						</slot>
					</ul>
				</div>
			</collapse-transition>
		</span>
	</span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";

export default {
	name: "side-enum-dynamic-group",
	components: {
		CollapseTransition,
	},
	data() {
		return {
			enumCollapse: false,
		};
	},
	computed: {
		links() {
		return this.$store.getters["getLinksByGroup"]('ENUM')
		},
		showNav() {
		return this.$store.getters["getLinksByGroup"]('ENUM').length > 0
		},
	},
	methods: {
	
		linkClick() {
			if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
				this.$sidebar.displaySidebar(false);
			}
		},
	},
};
</script>
